import { authRoles } from '../auth';


const navigationConfig = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'item',
        icon: 'dashboard',
        auth: authRoles.user,
        url: '/dashboard',
        exact: true
    },
    {
        id: 'workshop-dashboard',
        title: 'Dashboard',
        type: 'item',
        icon: 'dashboard',
        auth: authRoles.participant,
        training_allow: true,
        url: '/workshop-dashboard',
        exact: true
    },
    {
        id: 'compute',
        title: 'Compute / IDE',
        type: 'group',
        icon: 'apps',
        children: [
            {
                id: 'heidi-lab',
                title: 'Heidi Lab',
                type: 'collapse',
                icon: 'build',
                disabled: authRoles.demo,
                open: true,
                children: [
                    {
                        id: 'credential-manager',
                        title: 'Credentials Manager',
                        type: 'item',
                        icon: 'lock',
                        auth: authRoles.admin,
                        url: '/credentials',
                        exact: true
                    },
                    {
                        id: 'stack-manager',
                        title: 'Stack Manager',
                        type: 'item',
                        icon: 'album',
                        auth: authRoles.admin,
                        url: '/stacks',
                        exact: true
                    },
                    {
                        id: 'cluster-manager',
                        title: 'Cluster Manager',
                        training_allow: true,
                        type: 'item',
                        icon: 'dns',
                        url: '/clusters',
                        exact: true
                    }
                ],
            },
            {
                id: 'workloads',
                title: 'Workloads',
                type: 'collapse',
                icon: 'work',
                disabled: authRoles.demo,
                children: [
                    {
                        id: 'job-manager',
                        title: 'Job Manager',
                        type: 'item',
                        icon: 'work_outline',
                        url: '/jobs',
                        exact: true
                    },
                    {
                        id: 'file-manager',
                        title: 'File Manager',
                        type: 'item',
                        icon: 'folder',
                        url: '/files',
                        exact: true
                    }
                ]
            }
        ]
    },
    // Heidi Storage. Its own section, sitting next to Compute / IDE because
    // storage is a peer of compute, not a sub-tool of it.
    //
    // Nav labels are SHORT because the user is already inside Heidi - "Heidi
    // Storage > Heidi Documents" stutters. The full product names live in each
    // page's title and on every external surface, which is where they do their
    // work.
    {
        id: 'storage',
        title: 'Storage',
        type: 'group',
        icon: 'storage',
        children: [
            {
                id: 'storage-overview',
                title: 'Overview',
                type: 'item',
                icon: 'donut_large',
                url: '/storage',
                exact: true
            },
            {
                id: 'documents',
                title: 'Documents',
                type: 'item',
                icon: 'description',
                training_allow: true,
                url: '/storage/documents',
                exact: true
            },
            {
                id: 'storage-imaging',
                title: 'Imaging',
                type: 'item',
                icon: 'photo_library',
                training_allow: true,
                url: '/storage/imaging',
                exact: true
            },
            {
                id: 'storage-fast',
                title: 'Fast Storage',
                type: 'item',
                icon: 'flash_on',
                url: '/storage/fast',
                exact: true
            },
        ]
    },
    {
        id: 'education',
        title: 'Education',
        type: 'group',
        icon: 'school',
        children: [
            {
                id: "trainings",
                title: "Heidi Workshops",
                type: "item",
                icon: "class",
                auth: authRoles.instructor,
                url: "/trainings",
                exact: true
            },
            {
                id: "student-activity",
                title: "Heidi User Activity",
                type: "item",
                icon: "equalizer",
                auth: authRoles.instructor,
                url: "/student-activity",
                exact: true
            },
            {
                id: "heidi-lms",
                title: "Heidi LMS",
                type: "item",
                icon: "menu_book",
                // Org admins only: SSO is org-scoped, so it has no meaning for a
                // platform super-admin (and the hub refuses privileged SSO).
                auth: authRoles.orgAdmin,
                url: "/heidi-lms",
                exact: true
            }
        ]
    },
    {
        id: 'content-library',
        title: 'Content Library',
        type: 'group',
        icon: 'apps',
        children: [
            {
                id: 'apps',
                title: 'Applications',
                type: 'item',
                icon: 'apps',
                training_allow: true,
                url: '/heidi-apps',
                exact: true
            },
            {
                id: 'courses',
                title: 'Courses',
                type: 'item',
                icon: 'school',
                training_allow: true,
                url: '/courses',
                exact: true
            },
        ]
    },
    {
        id: 'cloud-tools',
        title: 'Cloud Tools',
        type: 'group',
        icon: 'cloud',
        auth: authRoles.superAdmin,
        children: [
            {
                id: 'cloud-analyzer',
                title: 'Heidi Cloud Analyzer',
                type: 'item',
                icon: 'cloud_circle',
                auth: authRoles.superAdmin,
                url: '/cloud-analyzer',
                exact: true
            },
            {
                id: 'cost-reports',
                title: 'Cost Reports',
                type: 'item',
                icon: 'assessment',
                auth: authRoles.superAdmin,
                url: '/cost-reports',
                exact: true
            }
        ]
    }
];

export default navigationConfig;

